<div class="dash-shell">
  <header class="page-head">
    <nav class="page-head__crumbs" aria-label="Breadcrumb">
      <a class="page-head__crumb" routerLink="/dashboard">Home</a>
      <span class="page-head__sep" aria-hidden="true">/</span>
      @if (entity(); as e) {
        <a class="page-head__crumb" [routerLink]="['/entity', e.short_id, 'dashboard']">{{
          e.name
        }}</a>
      } @else {
        <span class="page-head__crumb">Business</span>
      }
      <span class="page-head__sep" aria-hidden="true">/</span>
      <span class="page-head__crumb page-head__crumb--current" aria-current="page">Team</span>
    </nav>

    <div class="page-head__bar">
      <div class="page-head__titles page-head__titles--icon">
        <span class="page-head__icon" aria-hidden="true"
          ><app-icon name="users" [size]="24"
        /></span>
        <h1 class="page-head__title" data-testid="entity-team-title">Team &amp; invitations</h1>
        @if (entity(); as e) {
          <p class="page-head__subtitle">Manage who can act for {{ e.name }}</p>
        }
      </div>
      @if (entity(); as e) {
        @if (canInvite(e)) {
          <div class="page-head__actions">
            <button
              mat-flat-button
              color="primary"
              type="button"
              (click)="openInviteDialog(e)"
              data-testid="team-invite-btn"
            >
              <app-icon name="plus" [size]="18" />
              <span>Invite</span>
            </button>
          </div>
        }
      }
    </div>
  </header>

  @if (isLoading()) {
    <div class="loading-state" aria-label="Loading team" aria-busy="true">
      <div class="skeleton-rows">
        @for (i of [1, 2, 3]; track i) {
          <span class="sg-skeleton sg-skeleton--text sg-skeleton--w100"></span>
        }
      </div>
    </div>
  } @else if (loadError()) {
    <div class="sg-empty sg-empty--error sg-empty--bordered">
      <app-icon name="x-circle" [size]="40" />
      <p class="sg-empty__title">Couldn't load the team</p>
      <p class="sg-empty__desc">Something went wrong on our side.</p>
      <button mat-stroked-button type="button" (click)="reload()">
        <app-icon name="refresh" [size]="18" />
        Try again
      </button>
    </div>
  } @else if (entity(); as e) {
    @if (canInvite(e)) {
      <mat-card appearance="outlined" class="activity-card invites-card">
        <mat-card-content>
          @if (members().length > 0) {
            <p class="invites-list__label">Members</p>
            <ul class="invites-list">
              @for (m of members(); track m.id) {
                <li class="invites-list__item">
                  <span class="invites-list__avatar"><app-icon name="users" [size]="18" /></span>
                  <span class="invites-list__main">
                    <span class="invites-list__email">{{ m.name || m.email }}</span>
                    <span class="invites-list__meta">
                      {{ m.role_label }} · joined {{ m.joined_at | date: 'mediumDate' }}
                    </span>
                  </span>
                </li>
              }
            </ul>
          }

          @if (pendingInvitations().length === 0) {
            <p class="activity-card__empty">
              @if (members().length === 0) {
                No members yet. Invite the owner or a team member to join {{ e.name }}.
              } @else {
                No pending invitations.
              }
            </p>
          } @else {
            @if (members().length > 0) {
              <p class="invites-list__label">Pending invitations</p>
            }
            <ul class="invites-list">
              @for (inv of pendingInvitations(); track inv.id) {
                <li class="invites-list__item">
                  <span class="invites-list__avatar"><app-icon name="users" [size]="18" /></span>
                  <span class="invites-list__main">
                    <span class="invites-list__email">{{ inv.email }}</span>
                    <span class="invites-list__meta">
                      Invited as {{ inv.role_label }} · {{ inv.invited_at | date: 'mediumDate' }}
                    </span>
                  </span>
                  <span class="invites-list__pending">Pending</span>
                  <button
                    mat-button
                    type="button"
                    class="invites-list__cancel"
                    (click)="cancelInvitation(inv.id)"
                  >
                    Cancel
                  </button>
                </li>
              }
            </ul>
          }
        </mat-card-content>
      </mat-card>
    } @else {
      <div class="sg-empty sg-empty--bordered">
        <app-icon name="users" [size]="40" />
        <p class="sg-empty__title">No team access</p>
        <p class="sg-empty__desc">Only a business admin can manage members and invitations.</p>
      </div>
    }
  }
</div>
